import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOnetrustCookieComponent } from './custom-onetrust-cookie.component';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';


@NgModule({
  declarations: [CustomOnetrustCookieComponent],
  imports: [
    CommonModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OnetrustCookieComponent: {
          component: CustomOnetrustCookieComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class CustomOnetrustCookieModule {}
